export const MODERN_NAVIGATION = Object.freeze([
  { id: 'charting', label: 'Graficador', routeName: 'ChartingNext', available: true },
  { id: 'ipos', label: 'Próximas IPOs', routeName: 'UpcomingIpos', available: true },
  { id: 'reports', label: 'Informes', routeName: 'ReportsNext', available: true },
  { id: 'exercises', label: 'Ejercicios', routeName: 'ExercisesNext', available: true }
]);

export function isModernNavigationItemActive(item, route = {}) {
  const routeGroups = {
    charting: ['ChartingNext', 'ChartingNextEntry'],
    reports: ['ReportsNext', 'ReportNext'],
    exercises: ['ExercisesNext', 'ExercisesNextSession']
  };

  return routeGroups[item.id]
    ? routeGroups[item.id].includes(route.name)
    : route.name === item.routeName;
}
